"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCategroy = addCategroy;
exports.articleInfoApi = articleInfoApi;
exports.categroyByIds = categroyByIds;
exports.categroyUpdateStatus = categroyUpdateStatus;
exports.changeJdCateState = changeJdCateState;
exports.deleteCategroy = deleteCategroy;
exports.generateCateCodeApi = generateCateCodeApi;
exports.getPlatformOptions = getPlatformOptions;
exports.importCate = importCate;
exports.infoCategroy = infoCategroy;
exports.jdBindCate = jdBindCate;
exports.jdBindDetail = jdBindDetail;
exports.jdCateLists = jdCateLists;
exports.listCategroy = listCategroy;
exports.syncJdCate = syncJdCate;
exports.treeCategroy = treeCategroy;
exports.updateCategroy = updateCategroy;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 新增分类
 * @param data
 */
function addCategroy(data) {
  // return request({
  //     url: '/admin/category/save',
  //     method: 'POST',
  //     data,
  // });

  return (0, _requestMapi.default)({
    url: '/mapi/product/category/save',
    method: 'POST',
    data: data
  });
}

/**
 * 分类详情
 * @param pram
 */
function infoCategroy(pram) {
  var data = {
    id: pram.id
  };
  // return request({
  //     url: '/admin/category/info',
  //     method: 'GET',
  //     params: data,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/product/category/info',
    method: 'GET',
    params: data
  });
}

/**
 * 删除分类
 * @param pram
 */
function deleteCategroy(pram) {
  var data = {
    id: pram.id
  };
  // return request({
  //     url: '/admin/category/delete',
  //     method: 'GET',
  //     params: data,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/product/category/delete',
    method: 'POST',
    data: data
  });
}

/**
 * 分类列表
 * @param pram
 */
function listCategroy(pram) {
  var data = {
    limit: pram.limit,
    name: pram.name,
    page: pram.page,
    pid: pram.pid,
    status: pram.status,
    type: pram.type,
    platformId: pram.platformId
  };
  return (0, _request.default)({
    url: '/admin/category/list',
    method: 'GET',
    params: data
  });
}

/**
 * 分类数据tree数据
 * @param pram
 */
function treeCategroy(pram) {
  var data = {
    type: pram.type,
    status: pram.status,
    name: pram.name,
    platformId: pram.platformId
  };
  // return request({
  //     url: '/admin/category/list/tree',
  //     method: 'GET',
  //     params: data,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/product/category/list/tree',
    method: 'GET',
    params: data
  });
}

/**
 * 获取京东分类列表
 */
function jdCateLists(params) {
  return (0, _requestMapi.default)({
    url: '/mapi/thirdparty/admin/fusiling/jd/category/list',
    method: 'GET',
    params: params
  });
}

/**
 * 京东商品-修改分类状态
 */
function changeJdCateState(params) {
  var cateId = params.cateId,
    status = params.status;
  return (0, _request.default)({
    url: "/admin/fusiling/jd/category/status/".concat(cateId, "/").concat(status),
    method: 'POST',
    params: params
  });
}

/**
 * 京东分类绑定展示分类
 */
function jdBindCate(data) {
  return (0, _request.default)({
    url: '/admin/fusiling/jd/category/bind/add',
    method: 'post',
    data: data
  });
}

/**
 * 导入分类
 */
function importCate(data) {
  return (0, _request.default)({
    url: '/admin/fusiling/jd/category/inport',
    method: 'post',
    data: data
  });
}

/**
 * 京东分类绑定展示分类-详情
 */
function jdBindDetail(params) {
  return (0, _request.default)({
    url: '/admin/fusiling/jd/category/bind/detail',
    method: 'post',
    params: params
  });
}

/**
 * 京东分类-同步分类
 */
function syncJdCate() {
  return (0, _request.default)({
    url: '/admin/fusiling/jd/category/sync/category',
    method: 'get'
  });
}

/**
 * 更新分类
 * @param data
 */
function updateCategroy(data) {
  // return request({
  //     url: '/admin/category/update',
  //     method: 'POST',
  //     data,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/product/category/update',
    method: 'POST',
    data: data
  });
}

/**
 * 根据id集合查询对应分类列表
 * @param pram
 */
function categroyByIds(pram) {
  var data = {
    ids: pram.ids
  };
  return (0, _request.default)({
    url: '/admin/category/list/ids',
    method: 'GET',
    params: data
  });
}

/**
 * 修改 显示关闭状态
 * @param pram
 */
function categroyUpdateStatus(id) {
  // return request({
  //     url: `/admin/category/updateStatus/${id}`,
  //     method: 'GET',
  // });
  return (0, _requestMapi.default)({
    url: "/mapi/product/category/updateStatus/".concat(id),
    method: 'GET'
  });
}

/**
 * 文章详情
 * @param pram
 */
function articleInfoApi(params) {
  return (0, _request.default)({
    url: "/admin/article/info",
    method: 'GET',
    params: params
  });
}

/**
 *获取分类编码
 */
function generateCateCodeApi(data) {
  return (0, _request.default)({
    url: "/admin/generator/generateCateCode",
    method: 'POST',
    data: data
  });
}

/**
 * 获取运营平台列表
 * @param params
 */
function getPlatformOptions(params) {
  // return request({
  //     url: '/admin/companyapp/autoList',
  //     method: 'GET',
  //     params,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/company-app/autoList',
    method: 'get',
    params: params
  });
}